const sessionResultsPage = {
  "session-results.retry.waiting": "Waiting for replay…",
  "session-results.retry.compare": "Compare decisions",
  "session-results.retry.original": "Before",
  "session-results.retry.latest": "After",
  "session-results.retry.evaluating": "Evaluating decisions…",
  "session-results.retry.first-decision": "First decision: {{original}} → {{retry}} / 100 ({{difference}} points)",
  "session-results.retry.action": "Try again",
  "session-results.retry.launching": "Starting scenario…",
  "session-results.retry.description": "Practice without saving a new session or changing these results.",
  "session-results.retry.unavailable": "Open this scenario in the training app to try again.",
  "session-results.retry.error": "Could not start or analyse the retry. You can try again.",
  "session-results.title": "Session Results",
  "session-results.not-found": "We're still setting this one up. Come back later!",
  "session-results.section.results": "Results ({{ count }})",
  "session-results.section.feedback": "Feedback",
  "session-results.section.metrics": "Your metrics",
  "session-results.decision-insights": "Decision Insights",
  "session-results.beta.learn-more": "Beta · Learn more",
  "session-results.beta-dialog.title": "A smarter way to understand your decisions",
  "session-results.beta-dialog.p1": "You’re seeing our new decision model in beta — giving you a more precise view of your choices on the pitch.",
  "session-results.beta-dialog.p2": "As we refine it, you may notice small differences from your regular score, but that’s part of making it better.",
  "session-results.beta-dialog.footer": "You’re among the first to try it!",

  "session-results.results.summary": "Summary",
  "session-results.results.analysis": "Analysis",
  "session-results.results.overall-result": "Overall Result",
  "session-results.results.scenario-result-short": "S{{ index }}",
  "session-results.results.scenario-result": "Scenario {{ index }}",
  "session-results.results.pass-rating": "Pass Rating",
  "session-results.results.opportunity-rating": "Opportunity",
  "session-results.results.decision-making": "Decision Making",
  "session-results.results.scan-frequency": "Scan Frequency",
  "session-results.results.session-duration": "Session Duration",
  "session-results.results.scenarios-completed": "Scenarios Completed",
  "session-results.results.activities-completed": "Activities Completed",
  "session-results.results.performance-improvement": "Performance Improvement",
  "session-results.results.improvement": "Improvement",
  "session-results.results.decline": "Decline",
  "session-results.results.no-change": "No Change",
  "session-results.results.result": "Result {{ index }}",
  "session-results.results.decision-number": "{{ current }} of {{ total }}",

  "session-results.next-challenge": "Next Challenge",

  "session-results.bootcamp-complete.title": "Bootcamp Complete",
  "session-results.bootcamp-complete.description":
    "You’ve unlocked the full training experience. These are the core metrics you’ll use to improve your game.",
  "session-results.bootcamp-complete.continue": "Continue to Training",

  "session-results.bootcamp.title": "Nice Work!",
  "session-results.bootcamp.failed.title": "Nice Effort!",
  "session-results.bootcamp.failed.description":
    "You didn’t complete this session, but every attempt helps. Review your score and give it another go.",
  "session-results.bootcamp.progress-count": "{{ current }} of 7 complete",
  "session-results.bootcamp.progress-label": "Bootcamp progress",
  "session-results.bootcamp.continue": "Continue Bootcamp",
  "session-results.bootcamp.continue-to-full-experience": "Continue to full experience",
  "session-results.bootcamp.see-full-results": "See full results",
  "session-results.bootcamp.play-again": "Play Again",
  "session-results.bootcamp.final.description":
    "You’ve unlocked the full training experience. Your BYB IQ is the overall score you’ll use to track progress from here.",
  "session-results.bootcamp.final.tip-body": "Open your full results to review each metric, then continue into training to keep improving your game.",
  "session-results.bootcamp.passing-basics.description":
    "You’ve completed the Passing Basics Challenge and built the foundation for every session ahead.",
  "session-results.bootcamp.passing-basics.tip-body":
    "In the next sessions, you’ll learn the key skills behind great scanning, awareness, and decision-making.",
  "session-results.bootcamp.decision-making.description":
    "You’ve completed the Decision Challenge. Your Decision Score reflects the quality of the option you selected.",
  "session-results.bootcamp.decision-making.tip-body":
    "Scan for space, pressure, runs, and scoring opportunities before choosing the option that creates the most value.",
  "session-results.bootcamp.scan-rate.description":
    "You’ve completed Scan Rate. Your score shows how frequently you looked away from the ball to check your surroundings.",
  "session-results.bootcamp.scan-rate.tip-body": "Take quick, frequent looks around you, returning your attention to the ball between each scan.",
  "session-results.bootcamp.scan-timing.description":
    "You’ve completed Scan Timing. Your score shows how often you scanned at moments when it was safe to look away from the ball.",
  "session-results.bootcamp.scan-timing.tip-body":
    "Scan while the ball is travelling or between touches, then look back before the next player makes contact.",
  "session-results.bootcamp.awareness.description":
    "You’ve completed Awareness. Your score reflects how accurately you remembered the players you saw during your scans.",
  "session-results.bootcamp.awareness.tip-body":
    "During each scan, notice where players are and which team they belong to so you can recall the full picture.",
  "session-results.bootcamp.critical-scan.description":
    "You’ve completed Critical Scan. Your score shows how often you scanned while the ball was travelling towards you.",
  "session-results.bootcamp.critical-scan.tip-body":
    "Take one final look around after the pass is played, then return your attention to the ball before receiving it.",

  "session-result.title": "Session Result",
  "session-result.overview": "Overview",

  "session-result.session-score": "Session Score",

  "session-results.feedback.no-data": "No data available",
  "session-results.feedback.your-decision": "Your decision",
  "session-results.feedback.your-decision-short": "Your decision",
  "session-results.feedback.alternative-decision": "Alt. Decision",
  "session-results.feedback.alternative-decision-short": "Alt.",
  "session-results.feedback.no-decision": "No Decision made",
  "session-results.feedback.opportunity": "Opportunity",
  "session-results.feedback.safety": "Safety",

  "session-results.decision-filter.all": "All decisions",
  "session-results.decision-filter.shot": "Shots",
  "session-results.decision-filter.ground": "Ground passes",
  "session-results.decision-filter.through": "Through passes",
  "session-results.decision-filter.loft": "Lofted passes",
  "session-results.decision-filter.cross": "Crosses",
  "session-results.decision-filter.turnover": "Turnovers",
  "session-results.decision-filter.no-results": "No decisions match this filter",

  "session-results.previous-decision": "Previous Decision",
  "session-results.next-decision": "Next Decision",
  "session-results.decision-number": "Decision {{ number }}",
  "session-results.decision-panel.title": "Decision Score",
  "session-results.decision-panel.expected-goals": "Expected goals",
  "session-results.decision-panel.expected-threat": "Expected threat",
  "session-results.decision-panel.expected-pass": "Expected pass",
  "session-results.decision-panel.expected-pass-turnover": "Pass turnover",
  "session-results.decision-panel.no-selection": "Pick an alternative to inspect its score breakdown.",
  "session-results.decision-panel.feedback.excellent": "Excellent choice. This option led the available outcomes.",
  "session-results.decision-panel.feedback.great": "Strong decision. You were close to the best available option.",
  "session-results.decision-panel.feedback.good": "Solid option. There was still a better pass available here.",
  "session-results.decision-panel.feedback.improve": "There was a higher-value decision available in this moment.",
  "session-results.scores-dialog.title": "Understanding the Scores",
  "session-results.scores-dialog.subtitle": "These metrics help evaluate the quality and impact of your decisions.",
  "session-results.scores-dialog.xt.title": "Expected Threat (xT)",
  "session-results.scores-dialog.xt.description": "How much actions in a given position increase the likelihood of scoring.",
  "session-results.scores-dialog.xp.title": "Expected Pass (xP)",
  "session-results.scores-dialog.xp.description":
    "Probability that a pass successfully reaches its intended target, based on factors like pressure, distance, angle, and body orientation.",
  "session-results.scores-dialog.xpt.title": "Expected Pass Turnovers (xPT)",
  "session-results.scores-dialog.xpt.description": "Probability that a pass results in a turnover,",
  "session-results.scores-dialog.xg.title": "Expected Goals (xG)",
  "session-results.scores-dialog.xg.description": "Probability that a given shot results in a goal.",
  "session-results.scores-dialog.how-it-works.title": "How it works",
  "session-results.scores-dialog.how-it-works.description":
    "The engine uses a Risk-Adjusted Q-Value model. Every pass is evaluated by its expected upside (reward) weighted by the probability of completion, minus the weighted cost of a turnover at that specific location.",
  "session-results.scores-dialog.how-it-works.formula": "Q_{pass} = \\text{Reward}_{adj} \\cdot P_{comp} - \\text{Penalty}_{adj} \\cdot xPT",
  "session-results.scores-dialog.how-it-works.sub-formula": "P_{comp} = (1 - xPT) \\cdot xP \\quad | \\quad \\text{Reward} = \\max(xG, xT)",
  "session-results.scores-dialog.how-it-works.overall-score":
    "In simple terms, we calculate your net impact: the attacking value created minus the risk of an interception. This result is then compared to the optimal pass to generate your 0-100 score. A 100 score means you found the mathematically best option for a given scenario.",

  "session-results.video.2d": "2D",
  "session-results.video.3d": "3D",
  "session-results.video.vision-cone": "Vision Cone",
  "session-results.video.heatmap": "Heatmap",
  "session-results.video.time-display": "{{ currentTime }} / {{ duration }}",

  "session-results.scenario.replay": "Scenario Replay",
  "session-results.replay.error.title": "Unable to load replay",
  "session-results.replay.error.message": "Please try again later.",
  "session-results.filter-by.results": "Filter by results",

  "session-results.training-stats.title": "Training Stats",
  "session-results.training-stats.scenarios": "Scenarios",
  "session-results.training-stats.total-duration": "Total Duration",
  "session-results.training-stats.date": "Date",
  "session-results.training-stats.session-type": "Session Type",

  "session-results.scan-rate-maxed.pill": "Score Maxed",
  "session-results.scan-rate-maxed.title": "Maximum Efficiency Reached!",
  "session-results.scan-rate-maxed.intro":
    "Great work! You've maxed out the Scan Rate points towards your BYB IQ. Your exact raw score is still shown below, but the calculation caps at {{maxScanRate}} scans per second.",
  "session-results.scan-rate-maxed.why.title": "Why the cap?",
  "session-results.scan-rate-maxed.why.body":
    "Elite pros like Xavi peak at an ultra-efficient 0.83 scans/sec. At {{maxScanRate}} and above, you have already mastered the world class rate to scan between touches and track the pitch.",
  "session-results.scan-rate-maxed.whats-next.title": "What's next?",
  "session-results.scan-rate-maxed.whats-next.body":
    "Now that your scanning speed is world-class, the key to boosting your overall BYB IQ is to bring your other cognitive scores up to this same elite standard. Let's go!",
};

const motivators = {
  "session-result.outcome.bootcamp.excellent-1": "Excellent!",
  "session-result.outcome.bootcamp.excellent-1-subtitle": "A splendid performance.",

  "session-result.outcome.bootcamp.excellent-2": "Amazing!",
  "session-result.outcome.bootcamp.excellent-2-subtitle": "",

  "session-result.outcome.bootcamp.strong-1": "Great job!",
  "session-result.outcome.bootcamp.strong-1-subtitle": "A well executed session.",

  "session-result.outcome.bootcamp.strong-2": "Well done!",
  "session-result.outcome.bootcamp.strong-2-subtitle": "A great session.",

  "session-result.outcome.bootcamp.fair-1": "Nice!",
  "session-result.outcome.bootcamp.fair-1-subtitle": "You cleared your targets.",

  "session-result.outcome.bootcamp.fair-2": "Well done.",
  "session-result.outcome.bootcamp.fair-2-subtitle": "Advancing to the next division.",

  "session-result.outcome.bootcamp.poor-1": "Not quite there.",
  "session-result.outcome.bootcamp.poor-1-subtitle": "Try again to reach your targets.",

  "session-result.outcome.bootcamp.poor-2": "Room for improvement",
  "session-result.outcome.bootcamp.poor-2-subtitle": "Try again to reach your targets.",

  "session-result.outcome.excellent-1": "Outstanding job!",
  "session-result.outcome.excellent-1-subtitle": "Your hard work is paying off.",

  "session-result.outcome.excellent-2": "Exceptional performance!",
  "session-result.outcome.excellent-2-subtitle": "",

  "session-result.outcome.excellent-3": "Amazing! ",
  "session-result.outcome.excellent-3-subtitle": "It's clear your hard work is making a difference!!",

  "session-result.outcome.strong-1": "Great job!",
  "session-result.outcome.strong-1-subtitle": "You surpassed the targets with impressive margins.",

  "session-result.outcome.strong-2": "Good one!",
  "session-result.outcome.strong-2-subtitle": "Your effort was significantly above average—keep it up!",

  "session-result.outcome.strong-3": "A great session!",
  "session-result.outcome.strong-3-subtitle": "",

  "session-result.outcome.fair-1": "Good job!",
  "session-result.outcome.fair-1-subtitle": "Keep performing at this level to advance further!",

  "session-result.outcome.fair-2": "A solid session.",
  "session-result.outcome.fair-2-subtitle": "",

  "session-result.outcome.fair-3": "Well done!",
  "session-result.outcome.fair-3-subtitle": "A good session.",

  "session-result.outcome.poor-1": "Tough one.",
  "session-result.outcome.poor-1-subtitle": "Stick to the basics and try again.",

  "session-result.outcome.poor-2": "Not your best performance.",
  "session-result.outcome.poor-2-subtitle": "",

  "session-result.outcome.poor-3": "You did not reach the target.",
  "session-result.outcome.poor-3-subtitle": "Try again!",
};

export const sessionResults = {
  ...sessionResultsPage,
  ...motivators,
};
